// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bah1h6o{justify-content:center}
._1bsb7vkz{width:1pc}
._1e0c1txw{display:flex}
._4cvr1h6o{align-items:center}
._4t3i7vkz{height:1pc}
._4t3igktf{height:20px}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/renderer/node_modules/@atlaskit/smart-card/dist/esm/view/common/Icon.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sBAAsB;AACjC,WAAW,SAAS;AACpB,WAAW,YAAY;AACvB,WAAW,kBAAkB;AAC7B,WAAW,UAAU;AACrB,WAAW,WAAW","sourcesContent":["._1bah1h6o{justify-content:center}\n._1bsb7vkz{width:1pc}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._4t3i7vkz{height:1pc}\n._4t3igktf{height:20px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
